export class CateringQrCodeInfo {
  pfr: string;
  modul: string;
  time: string;

  constructor(pfr: string, modul: string, time: string) {
    this.pfr = pfr;
    this.modul = modul;
    this.time = time;
  }
}

export class BettingQrCodeInfo {
  idtiket: string;
  modul: string;
  idlokacije: string;
  idkasa: string;
  uplata: string;
  kvota: string;
  kvote: string;
  type: string;
  brparova: string;
  time: string;
  marketUrl: string;

  constructor(
    idtiket: string,
    modul: string,
    idlokacije: string,
    idkasa: string,
    uplata: string,
    kvota: string,
    kvote: string,
    type: string,
    brparova: string,
    time: string,
    marketUrl: string
  ) {
    this.idtiket = idtiket;
    this.modul = modul;
    this.idlokacije = idlokacije;
    this.idkasa = idkasa;
    this.uplata = uplata;
    this.kvota = kvota;
    this.kvote = kvote;
    this.type = type;
    this.brparova = brparova;
    this.time = time;
    this.marketUrl = marketUrl;
  }
}
